const day = 86400; // seconds in a day
export function transformTimestampToLocalTime(timestamp) {
    const date = new Date(timestamp * 1000);
    const timezoneOffsetSeconds = date.getTimezoneOffset() * 60;
    return timestamp - timezoneOffsetSeconds;
}
export function transformToStringifiedDateAndTime(timeValue, isShortFormat) {
    const timestamp = new Date(timeValue * 1000);
    const date = timestamp.toLocaleDateString("de-DE", {
        timeZone: "Europe/Berlin",
        month: "2-digit",
        day: "2-digit",
    });
    const time = isShortFormat
        ? timestamp
            .toLocaleTimeString("de-DE", {
            timeZone: "Europe/Berlin",
            hour: "2-digit",
            minute: "2-digit",
        })
            .slice(0, 5)
        : timestamp.toLocaleTimeString("de-DE", { timeZone: "Europe/Berlin" });
    return `${date} ${time}`;
}
export function transformToStringifiedDate(timeValue) {
    const timestamp = new Date(timeValue * 1000);
    const date = timestamp.toLocaleDateString("de-DE", {
        timeZone: "Europe/Berlin",
        day: "2-digit",
        month: "short",
    });
    const weekday = timestamp.toLocaleDateString("de-DE", {
        timeZone: "Europe/Berlin",
        weekday: "short",
    });
    return `${weekday}. ${date}`;
}
export function transformToStringifiedTime(timeValue) {
    const timestamp = new Date(timeValue * 1000);
    return timestamp.toLocaleTimeString("de-DE", { timeZone: "Europe/Berlin" });
}
export function toMidnight(date) {
    date.setMinutes(0);
    date.setHours(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}
export function toDataRange(range) {
    const [start, end] = range;
    return [~~(start.getTime() / 1000) - day, ~~(end.getTime() / 1000) + day];
}
//current day: daysPast = 0, daysForward = 1
export function getDateRange(daysPast, daysForward) {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - daysPast);
    //start at midnight
    startDate.setHours(0, 0, 0, 0);
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + daysForward - 1);
    //end at midnight
    endDate.setHours(23, 59, 59, 999);
    return [startDate, endDate];
}
export function getAutoDateRange() {
    const width = window.innerWidth;
    if (width <= 480) {
        return getDateRange(0, 1);
    }
    else if (width <= 640) {
        return getDateRange(1, 2);
    }
    else {
        return getDateRange(2, 5);
    }
}
export function getMonthlyRange() {
    const startDate = new Date();
    startDate.setHours(0, 0, 0, 0);
    startDate.setDate(1);
    const endDate = new Date();
    endDate.setDate(1);
    endDate.setMonth(endDate.getMonth() + 1);
    endDate.setHours(0, 0, 0, -1);
    return [startDate, endDate];
}
//# sourceMappingURL=utils.js.map